import { useMemo } from 'react';

import { getMultiPromptFields } from 'src/data/generationTool';

import { useMultiPromptTemplate } from './useMultiPromptTemplate';

export const useMultiPromptTemplateFieldsData = ({ generationTool, customTemplateId }) => {
  const template = useMultiPromptTemplate(customTemplateId);

  return useMemo(() => {
    // If we are in a custom multi-prompt tool, we need to get the blocks from the template
    if (customTemplateId) {
      const fields = template?.fields;
      if (!fields) {
        return null;
      }

      const fieldsData = {
        titles: {},
        placeholders: {},
        order: [],
      };
      fields.forEach((field) => {
        const fieldKey = field.name.toLowerCase().replace(/ /g, '_');
        fieldsData.titles[fieldKey] = field.name;
        fieldsData.placeholders[fieldKey] = field.description;
        fieldsData.order.push(fieldKey);
      });
      return fieldsData;
    }

    // otherwise, we can use the default fields for this generation tool
    return getMultiPromptFields(generationTool);
  }, [customTemplateId, generationTool, template?.fields]);
};
